var _circle, _circle2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFooterBg = function SvgFooterBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 669 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 557.5,
    cy: 111.5,
    r: 111.5,
    fill: "#D70000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 557.5,
    cy: 334.5,
    r: 111.5,
    fill: "#D70000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#footer-bg_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334.5,
    cy: 334.5,
    r: 111.5,
    fill: "#D70000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223 223a222.991 222.991 0 0 1 65.315-157.685A223.003 223.003 0 0 1 446 0v223H223ZM-.001 223H223v223H-.001z",
    fill: "#D70000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "footer-bg_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 223,
    width: 223,
    height: 223,
    rx: 111.5,
    fill: "#fff"
  })))));
};
export default SvgFooterBg;